export default __webpack_public_path__ + "media/images/preview-b54f26bee9fa05a27b4f295129ca6d4a.png";